import { makeAutoObservable } from 'mobx';
import FirebaseStore from './firebaseStore';
import { UserStore } from './userStore';
import { createStripeAccountSession, createStripeConnectedAccount, getBankAccountSetupStatus, createPADSetup, getStripeConnectAccountId, CreatePADSetupResult } from '../utils/apiClient';
import { IAccountConnectionStatusResponse } from 'realhaus-sdk';

export class BankAccountStore {
  constructor(private fireStore: FirebaseStore, private userStore: UserStore) {
    makeAutoObservable(this);
  }

  getStripeConnectAccountId = async (): Promise<string | undefined> => {
    const uid = this.userStore.userId;
    if (!uid) throw new Error('Not Authenticated');

    const token = await this.userStore.getUserToken() || '';
    return await getStripeConnectAccountId({ token, body: {} });
  }

  createStripeConnectedAccount = async (): Promise<string | undefined> => {
    const uid = this.userStore.userId;
    if (!uid) throw new Error('Not Authenticated');

    const token = await this.userStore.getUserToken() || '';

    const res = await createStripeConnectedAccount({ token, body: {} });
    return res;
  }

  // perhaps do not expose account Id client-side
  createStripeAccountSession = async (accountId: string): Promise<string | undefined> => {
    const uid = this.userStore.userId;
    if (!uid) throw new Error('Not Authenticated');

    const token = await this.userStore.getUserToken() || '';
    const request = { token, body: { accountId } }

    const res = await createStripeAccountSession(request);
    return res;
  }

  bankAccountSetupStatusForUser = async (userId: string): Promise<IAccountConnectionStatusResponse | undefined> => {
    if (!this.userStore.userId) throw new Error('Not Authenticated');

    const token = await this.userStore.getUserToken() || '';
    const request = { token, body: { userId } }

    const res = await getBankAccountSetupStatus(request);

    return res;
  }

  createPADSetup = async(leaseId: string): Promise<CreatePADSetupResult> => {
    if (!this.userStore.userId) throw new Error('Not Authenticated');

    const token = await this.userStore.getUserToken() || '';
    const request = { token, body: { leaseId } }

    return await createPADSetup(request);
  }
}
